import React, {memo} from 'react';
import {FormattedMessage} from 'react-intl';

export const ErrorComponent: React.FC = memo(() => <p><FormattedMessage id="Label.Error"/></p>);
